// extracted by mini-css-extract-plugin
export default {"container":"raiseTicketPage_container__lGFcO","top":"raiseTicketPage_top__h2LVi","bottom":"raiseTicketPage_bottom__84HPY"};